import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getMipFormsWithAttachment } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { MipFormAttachmentRes } from '@dealstack/shared/lib/generated/models/MipFormAttachmentRes';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const useMipFormsWithAttachment = (
	params: { dealId: string; programmeId: string; kycWorkflowId: string | undefined },
	enabled: boolean
): UseQueryResult<MipFormAttachmentRes[] | undefined, unknown> => {
	return useQuery({
		queryKey: [
			API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_KYC_FORMS_KYC_WORKFLOW_KYCWORKFLOWID_GET,
			params.kycWorkflowId,
		],
		queryFn: () =>
			getMipFormsWithAttachment({
				dealId: params.dealId,
				programmeId: params.programmeId,
				kycWorkflowId: params.kycWorkflowId ?? '',
			}),
		select: (data: ApiV1.Response<MipFormAttachmentRes[]>) => data.payload,
		enabled: enabled && !!params.dealId && !!params.programmeId && !!params.kycWorkflowId,
	});
};
